import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Consorcio } from '../../model/consorcio';
import { ArticuloService } from '../../services/articulo.service';
import { Articulo } from '../../model/articulo';
@Component({
  selector: 'app-articulo-buscar',
  templateUrl: './articulo-buscar.component.html',
  styleUrls: ['./articulo-buscar.component.css']
})
export class ArticuloBuscarComponent implements OnInit {


  @Input() consorcio: Consorcio;
  @Input() nombreArticulo: string;

  @Input() articulo: Articulo;
  @Output() onArticuloSeleccionado = new EventEmitter<Articulo>();

  public codigoArticulo: string;
  public codigoArticuloSeleccionado: string;

  public articulos: Articulo[];


  public query: any;

  constructor(private _articuloService: ArticuloService) { }

  ngOnInit() {

  }


  cargarArticulos(value: string) {

    if (this.consorcio === null) {
      return;
    }

    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "queryText": value };

    this._articuloService.getArticulos(this.query)
      .subscribe(
      data => this.articulos = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  cargarArticulo(value: string) {

    if (this.consorcio === null) {
      return;
    }

    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "queryText": value };

    this._articuloService.getArticuloByCodigo(this.query)
      .subscribe(
      data => {
      this.articulos = data;
        this.articulo = this.articulos[0];
        this.articuloSeleccion();
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  


  onEnter(value: string) {

    if (value === "") {
      return;
    }

    this.cargarArticulos(value);

  }

  articuloSeleccion() {
    this.codigoArticuloSeleccionado = this.articulo.codigoArticulo;
    this.onArticuloSeleccionado.emit(this.articulo)
  }


  limpiarDatos() {
    this.codigoArticuloSeleccionado = "";
    this.codigoArticulo = "";
    this.articulos = [];
  }

}


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/articulo-buscar/articulo-buscar.component.ts